import { isNotifEnabled, type NotifPrefs } from "@/lib/notificationPrefs";
import type { LiveEvent } from "@/lib/supabase/liveChannel";

/**
 * Banner notifikasi MASUK — notifikasi baru yang tiba saat pembeli sedang
 * belanja muncul sebagai banner singkat di atas layar (`NotificationBanner`),
 * tak cuma sebagai angka di lonceng header. Logika murni; mesinnya
 * `NotificationProvider`.
 */

/** Lama banner tampil sebelum menghilang sendiri. */
export const NOTIF_BANNER_MS = 5000;

/**
 * Tampilkan banner untuk event realtime ini? Hanya bila SEMUA terpenuhi:
 *  - INSERT id yang belum pernah terlihat sesi ini (broadcast boleh mengirim
 *    ulang; UPDATE/DELETE bukan kabar baru);
 *  - jenisnya aktif di Pengaturan Notifikasi, atau notif `important`;
 *  - pembeli TIDAK sedang di halaman Notifikasi (daftarnya sendiri sudah
 *    bertambah di sana);
 *  - tab terlihat (banner di tab tersembunyi tak terbaca siapa pun);
 *  - Notifikasi HP (push) perangkat ini TIDAK aktif — service worker
 *    (`public/sw.js`) menampilkan notif sistem untuk setiap push, juga saat
 *    aplikasi terbuka, jadi banner di atasnya adalah peringatan dobel.
 */
export function shouldShowNotifBanner(input: {
  event: LiveEvent;
  isNew: boolean;
  type: string | null | undefined;
  important: boolean | null | undefined;
  prefs: NotifPrefs;
  pathname: string;
  pushActive: boolean;
  visible: boolean;
}): boolean {
  if (input.event !== "INSERT" || !input.isNew) return false;
  if (input.pushActive || !input.visible) return false;
  if (input.pathname === "/notifications" || input.pathname.startsWith("/notifications/")) {
    return false;
  }
  return input.important === true || isNotifEnabled(input.prefs, input.type ?? "");
}
